import React from 'react';
import ReadingControlIcon from './ReadingControlIcon';
import { dummyClick } from '../utilities';

const ReadingControls = ({ t, prevPageClicked, nextPageClicked, zoomIn, zoomOut, toggleFullscreen }) => {
  return <div className="a-reader-nav">
    <ReadingControlIcon src="/images/webreader/ic-prev.svg" title={t.previousPage} className="slide-in-left-0" onClick={prevPageClicked} />
    <ReadingControlIcon src="/images/webreader/ic-next.svg" title={t.nextPage} className="slide-in-left-1" onClick={nextPageClicked} />
    <ReadingControlIcon src="/images/webreader/ic-zoom-in.svg" title={t.zoomIn} className="slide-in-left-2" onClick={zoomIn} />
    <ReadingControlIcon src="/images/webreader/ic-zoom-out.svg" title={t.zoomOut} className="slide-in-left-3" onClick={zoomOut} />
    <ReadingControlIcon src="/images/webreader/ic-full-screen.svg" title={t.fullscreen} className="slide-in-left-4" onClick={toggleFullscreen}
                        id="toggle-fullscreen"
    />
  </div>
}

ReadingControls.defaultProps = {
  t: {
    previousPage: 'EN previousPage',
    nextPage: 'EN nextPage',
    zoomIn: 'EN zoomIn',
    zoomOut: 'EN zoomOut',
    fullscreen: 'EN fullscreen',
  },
  prevPageClicked: dummyClick,
  nextPageClicked: dummyClick,
  zoomIn: dummyClick,
  zoomOut: dummyClick,
  toggleFullscreen: dummyClick
};

export {ReadingControls};
